export const handleNavigate = ({ url, params, navigate }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const session = queryParams.get("session");

  let newQueryParamString = `session=${session}`;
  Object.entries(params).forEach(([key, value]) => {
    newQueryParamString += `&${key}=${value}`;
  });

  navigate(`${url}?${newQueryParamString}`);
};
